import { render, staticRenderFns } from "./FromWarehouseBlock.vue?vue&type=template&id=5c169ee1&scoped=true"
import script from "./FromWarehouseBlock.vue?vue&type=script&lang=js"
export * from "./FromWarehouseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c169ee1",
  null
  
)

export default component.exports